export default [
  {
    id: '_id',
    text: 'Id',
    title: 'Código de identificação da ligação no sistema',
    checked: false
  },
  {
    id: 'start',
    text: 'Início',
    title: 'Inicio da ligação/pausa no sistema',
    checked: true
  },
  {
    id: 'event',
    text: 'Evento',
    title: 'Ligação, LoginRamal, Pausa',
    checked: true
  },
  {
    id: 'type',
    text: 'Tipo',
    title:
      'Ligação (entrante, sainte, interna), pausa (produtiva, improdutiva)',
    checked: true
  },
  {
    id: 'agent',
    text: 'Agente',
    title: 'Agente que recebeu ou fez a ligação/pausa',
    checked: true
  },
  {
    id: 'extension',
    text: 'Ramal',
    title: 'Ramal onde o agente recebeu ou fez a ligação/pausa',
    checked: true
  },
  {
    id: 'finalized',
    text: 'Fim',
    title: 'Momento em que a ligação/pausa foi finalizada no sistema',
    checked: true
  },
  {
    id: 'total_time',
    text: 'Duração',
    title: 'Tempo que a ligação/pausa durou no sistema',
    checked: true
  },
  {
    id: 'trunk',
    text: 'Tronco',
    title:
      'Prefixo do tronco para o qual o cliente ligou ex: 57219000 o tronco seria: N9000',
    checked: true
  },
  {
    id: 'client',
    text: 'ClienteNum',
    title: 'Número do telefone do cliente',
    checked: true
  },
  {
    id: 'forwarder',
    text: 'Encaminhador',
    title: 'Quem encaminhou a ligação para o agente (agente, grupo, etc.)',
    checked: true
  },
  {
    id: 'forwarderNum',
    text: 'Encaminhador (número)',
    title:
      'Número que encaminhou a ligação para o agente (ramal, piloto de grupo, etc.)',
    checked: true
  },
  {
    id: 'outexp',
    text: 'Fora de expediente (grupo)',
    title: 'Grupo(s) fora de expediente',
    checked: false
  },
  {
    id: 'forwardered',
    text: 'Encaminhada (hora)',
    title: 'Momento em que a chamada foi encaminhada para o agente',
    checked: true
  },
  {
    id: 'tforwardered',
    text: 'Encaminhada (espera)',
    title:
      'Tempo que demorou para a chamada ser encaminhada do encaminhador (grupo ou transferencia) para o agente',
    checked: false
  },
  {
    id: 'distribuited',
    text: 'Entregue',
    title:
      'Momento em que a chamada foi entregue ao grupo/agente (recebimento direto)',
    checked: false
  },
  {
    id: 'result',
    text: 'Resultado',
    title: 'Resultado da ligação (Atendida, Não atendida, Abandonada',
    checked: true
  },
  {
    id: 'cause',
    text: 'Motivo',
    title:
      'Motivo do resultado (captura, encaminhamento, transferencia, atendimento normal, etc)',
    checked: true
  },
  {
    id: 'restime',
    text: 'Momento',
    title: 'Momento em que a chamada foi (Atendida, Abandonada, Não atendida)',
    checked: true
  },
  {
    id: 'tanswering',
    text: 'Atendimento',
    title: 'Tempo de duração do atendimento da ligação',
    checked: false
  },
  {
    id: 'tringg',
    text: 'Ring',
    title: 'Tempo de ring da ligação no agente',
    checked: true
  },
  {
    id: 'twaiting',
    text: 'Espera (fila)',
    title:
      'Tempo de espera do momento que a ligação entrou em fila até ser atendida ou não',
    checked: true
  },
  {
    id: 'ttwaiting',
    text: 'Espera (total)',
    title:
      'Tempo de espera do momento que a ligação entrou no PABX até ser atendida ou não',
    checked: true
  },
  {
    id: 'resume',
    text: 'Finalizada/Transferida',
    title:
      'Resumo da ligação neste agente/extensão (Finalizada, Transferida para outro destino, etc)',
    checked: true
  },
  {
    id: 'score',
    text: 'Avaliação',
    title: 'Avaliação do cliente',
    checked: false
  }
];
